import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';

const RadioGroup = ({
  options,
  radioGroupLabel,
  setValue,
  sectionClassName = '',
  radioGroupLabelFont = 'font-bold',
  radioGroupLabelClasses = 'mb-5',
  spaceY = 'space-y-4',
}) => {
  const [formattedOptions, setFormattedOptions] = useState([]);

  useEffect(() => {
    const formatted = options.map((option) => {
      return {
        ...option,
        checked: false,
      };
    });
    setFormattedOptions(formatted);
  }, [options]);

  // handle radio button change
  const onChange = (id) => {
    const checkedOption = formattedOptions.find((option) => option.id === id);
    setFormattedOptions((prev) => {
      return prev.map((option) => ({
        ...option,
        checked: option.id === id,
      }));
    });
    setValue(checkedOption);
  };
  // if no options return null
  if (formattedOptions.length === 0) return null;

  return (
    <fieldset>
      <legend
        className={`${radioGroupLabelFont} ${radioGroupLabelClasses}`}
      >
        {radioGroupLabel}
      </legend>
      <section className={`${spaceY} ${sectionClassName}`}>
        {formattedOptions?.map((option) => (
          <RadioButton key={option.id} option={option} onChange={onChange} />
        ))}

      </section>
    </fieldset>
  );
};

RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  radioGroupLabel: PropTypes.string.isRequired,
  radioGroupLabelFont: PropTypes.string,
  radioGroupLabelClasses: PropTypes.string,
  spaceY: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  sectionClassName: PropTypes.string,
};

export default RadioGroup;
